if (!window.coveoTrackingInitialized) {
//Évite de charger le fichier plusieurs fois afin de prévenir les appels en double vers Coveo
    window.coveoTrackingInitialized = true;
    const debouncedTrack = $.debounce(clickTrack, 300);
    $(document).on('click', '.tile-product .product-details-link, .tile-product .pt__visual a', clickTrack);
    $(document).on('contextmenu', '.tile-product .product-details-link, .tile-product .pt__visual a', debouncedTrack);
    $(document).on('click', '.tile-product .btn--displayFlavours', debouncedTrack);
    $(document).on('click', '.tile-product .pt__content--actions .action__favorite', debouncedTrack);
    $(document).on('click', '.tile-product .pt__content--actions .cart-plus', debouncedTrack);
    $(document).on('click', '.tile-product .pt__content--actions .plus-addToCart', debouncedTrack);
    $(document).on('click', '.tile-product .pt__content--actions .minus-addToCart', debouncedTrack);
    //Le premier add to cart
    $(document).on('click', '.tile-product .pt__content--actions .button-tile-addToCart.action__add-to-cart', debouncedTrack);
    //Cart Genius
    $(document).on('click', '.cartGeniusSidePanelProducts .item-addToCart .btn--plus.plus-addToCart-from-cartgenius', debouncedTrack);
    $(document).on('click', '.cartGeniusSidePanelProducts .item-addToCart .minus-addToCart-from-cartgenius', debouncedTrack);
    $(document).on('click', '.cartGeniusSidePanelProducts .action__favorite', debouncedTrack);

    function clickTrack(event) {
        UAEvents.click(
            event.target,
            'product',
            'documentOpen',
            '.products-search--grid .tile-product',
            '.tile-product',
            true
        );
    }
}
